import { render, staticRenderFns } from "./CharityComponent.vue?vue&type=template&id=4113f9ad&scoped=true&"
import script from "./CharityComponent.vue?vue&type=script&lang=js&"
export * from "./CharityComponent.vue?vue&type=script&lang=js&"
import style0 from "./CharityComponent.vue?vue&type=style&index=0&id=4113f9ad&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4113f9ad",
  null
  
)

export default component.exports